import { initializeApp } from 'firebase/app';



const config = {
  apiKey: "AIzaSyDpGEhdDfJUIpSUFTC-oPLlTUgbjLXrIAA",
  authDomain: "hulum-b91ca.firebaseapp.com",
  projectId: "hulum-b91ca",
  storageBucket: "hulum-b91ca.appspot.com",
  messagingSenderId: "316616610072",
  appId: "1:316616610072:web:d3a7f5fbfcebcf4711ce6d"
};


const app = initializeApp(config);

export default app;